import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.pageTitle}>{t("normal.serviceTerms")}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: t("2esim.serviceTerms.content", {
              brand: process.env.REACT_APP_PROD_NAME_DEV,
              contactmail: process.env.REACT_APP_CS_MAIL_ADDRESS,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default Terms;
